/** A placeholder for a photo the session renderer already holds carries no pixels. */
export interface StubCandidate {
  data?: Uint8Array;
  version?: string;
}

/**
 * Refs whose zero-byte stub no longer has a texture behind it: the renderer lost it (worker crash, reset) after the
 * stub was made. Such a stub would render as an empty frame, so only a fresh decode brings the photo back.
 * `isResident` answering undefined means "unknown", not "gone".
 */
export function evictedStubRefs(
  images: Readonly<Record<string, StubCandidate>>,
  isResident: (ref: string, version: string | undefined) => boolean | undefined,
): string[] {
  return Object.entries(images)
    .filter(([ref, img]) => img.data?.length === 0 && isResident(ref, img.version) === false)
    .map(([ref]) => ref);
}
